import { UPDATE_ACTIVITIES } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_ACTIVITIES:
      return { ...state, ...action.payload.entities.activities };
    default:
      return state;
  }
};

export default reducer;
